import React, { useState } from 'react'
import { Form, InputGroup, Button, Alert } from "react-bootstrap";
import { serPermissions } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';

export default function Permission() {
  const [inputValue,setInputValue]=useState('')
  const [optionValue,setOptionValue]=useState('')
  const {lg}=useSelector((state)=>state.language)

  // 信息对话框
  const [msgInfo, setMsgInfo] = useState('');

  const handleBtnClick=() => {
    if(msgInfo) return;
    if(!inputValue||!optionValue){
      setMsgInfo(`0${langList.permission1[lg]}`);
      return;
    };
    const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
    if (!emailRegex.test(inputValue)) {
      setMsgInfo(`0${langList.permission2[lg]}`);
      return;
    };
    serPermissions({name:inputValue.trim(),option:optionValue})
    .then(res =>{
      const code=res.code;
      if(code===35){
        setMsgInfo(`1${langList.permission3[lg]}`);
      }else if(code===3){
        setMsgInfo(`0${langList.permission4[lg]}`);
      }else{
        setMsgInfo(`0${langList.public8[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
  };

  const handleImgPasteClick= async () => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      setInputValue(clipboardText);
    } catch (error) {
      setMsgInfo(`0${langList.permission5[lg]}`);
    }
  };

  const handleImgCopyClick= async () => {
    try {
      await navigator.clipboard.writeText(inputValue);
    } catch (error) {
      setMsgInfo(`0${langList.permission6[lg]}`);
    }
  };

  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )
  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };

  return (
    <div>
      <InputGroup className='mt-4'>
        <InputGroup.Text onClick={handleImgPasteClick} style={{cursor:'pointer'}}>
          <img src='./pic/clipboard-plus.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control id='userpermissions' type="text"
          placeholder={langList.permission7[lg]}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <InputGroup.Text onClick={handleImgCopyClick} style={{cursor:'pointer'}}>
          <img src='./pic/copy.svg' alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <Form.Select id='permisselect' className='mt-3' value={optionValue}
        onChange={(e) => setOptionValue(e.target.value)}
      >
        <option value=''>{langList.permission8[lg]}</option>
        <option value="100">{langList.permission9[lg]}</option>
        <option value="200">{langList.permission10[lg]}</option>
        <option value="300">{langList.permission11[lg]}</option>
        <option value="2">{langList.permission12[lg]}</option>
        <option value="1">{langList.permission13[lg]}</option>
        <option value="0">{langList.permission14[lg]}</option>
      </Form.Select>
      {msgInfo && chip}
      <div className='text-center mt-4 mb-3'>
        <Button
          variant="primary"
          className='w-25'
          onClick={handleBtnClick}
        >{langList.permission15[lg]}</Button>
      </div>
    </div>
  );
}
